import { render } from "./village_master.vue?vue&type=template&id=3ba150ac&scoped=true"
import script from "./village_master.vue?vue&type=script&lang=js"
export * from "./village_master.vue?vue&type=script&lang=js"

import "./village_master.vue?vue&type=style&index=0&id=3ba150ac&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba150ac"]])

export default __exports__